import type { OfficeGroup, OfficeGroups, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';

/**
 * @deprecated PERFORMANCE This function returns an entity object and forces unnecessary re-renders.
 * This must be replaced with a `getOfficeGroupField` selector.
 */
export const findById: FindById<'officeGroups'> = createFindById('officeGroups');
/**
 * @deprecated PERFORMANCE This function returns an entity object and forces unnecessary re-renders.
 * This must be replaced with a `getOfficeGroupFieldThrows` selector.
 */
export const findByIdThrows: FindByIdThrows<'officeGroups'> = createFindByIdThrows('officeGroups');

type GetOfficeGroupsState = (state: YammerState) => OfficeGroups;
export const getOfficeGroupsState: GetOfficeGroupsState = (state) => state.officeGroups;

type GetFulfilledOfficeGroups = (state: YammerState) => Record<string, OfficeGroup>;
export const getFulfilledOfficeGroups: GetFulfilledOfficeGroups = (state) => state.officeGroups.fulfilled.byId;
